module.exports = __webpack_public_path__ + "img/gif-2.303bca1d.gif";